import {HttpAxiosRequest} from "../httpAxiosBase";
import {
    AuthorizationRequest,
    AuthorizationRequestFields, AuthToken,
    AuthorizationResponse, ChangePasswordData, ChangePasswordDataFields
} from "../../types/user/authData";
import {ConfigurationEconde, configurationEncoder} from "../../utils/configuration";
import { CryptoJSHelper } from "src/utils/helpers";
import {BaseResponse, EntityResponse} from "../../types/baseEntities";

export const HttpAuth = {
    getEndpoint: (url: string) => `auth${url}`,

    authenticateUser: async (requestParams: AuthorizationRequest): Promise<AuthorizationResponse> => {
        const encoder: ConfigurationEconde = await configurationEncoder.getConfiguration();
        const encryptPassword: string = CryptoJSHelper.encrypt(encoder, requestParams[AuthorizationRequestFields.Password]);
        
        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint(""),
            {
                [AuthorizationRequestFields.Mail]: requestParams.mail,
                [AuthorizationRequestFields.ClientIp]: requestParams.ipClient,
                [AuthorizationRequestFields.Password]: encryptPassword,
                [AuthorizationRequestFields.ModuleCod]: requestParams.codModulo //login (onboarding)
            }
        );
    },

    ping: async () : Promise<number> => {
        return HttpAxiosRequest.get(
            HttpAuth.getEndpoint("/ping")
        )
    },
    
    changePassword: async (data: ChangePasswordData) : Promise<BaseResponse> => {
        const encoder: ConfigurationEconde = await configurationEncoder.getConfiguration();
        const encryptedActualPassword: string = CryptoJSHelper.encrypt(encoder, data[ChangePasswordDataFields.PasswordActual]);
        const encryptedNewPassword: string = CryptoJSHelper.encrypt(encoder, data[ChangePasswordDataFields.PasswordNueva]);
        
        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint('/cambiar-contrasena'),
            {
                [ChangePasswordDataFields.IdUsuario]: data[ChangePasswordDataFields.IdUsuario],
                [ChangePasswordDataFields.PasswordActual]: encryptedActualPassword,
                [ChangePasswordDataFields.PasswordNueva]: encryptedNewPassword
            }
        )
    },

    forgotPassword: (mail: string): Promise<EntityResponse> => {
        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint("/olvide-contrasena"),
            {
                Mail: mail
            }
        );
    },

    confirmChangePassword: (guid: string) : Promise<EntityResponse> => {
        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint("/confirmar-contrasena"),
            {
                identificadorWeb: guid
            }
        );
    },
    
    refreshToken: () : Promise<AuthToken> => {
        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint("/refresh-token"),{}
        )
    },
    
    validateToken: (): Promise<AuthorizationResponse> => {

        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint("/validar-token"),
            {}
        );
    },
}